import type { DefiTravail } from '../api/inscription';
export function calculerPreuve(defi: DefiTravail, signal: AbortSignal): Promise<string> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) { reject(new Error('Contrôle annulé.')); return; }
    const worker = new Worker(new URL('./inscription.worker.ts', import.meta.url), { type: 'module' });
    const finir = () => { worker.terminate(); signal.removeEventListener('abort', annuler); clearTimeout(delai); };
    const annuler = () => { finir(); reject(new Error('Contrôle annulé.')); };
    const delai = setTimeout(() => { finir(); reject(new Error('Le contrôle anti-abus a expiré. Recommencez.')); }, Math.max(0, Math.min(120000, defi.expire_s * 1000 - Date.now())));
    signal.addEventListener('abort', annuler, { once: true });
    worker.onmessage = (e: MessageEvent<{ solution?: string; erreur?: string }>) => {
      finir(); if (e.data.solution !== undefined) resolve(e.data.solution); else reject(new Error(e.data.erreur ?? 'Contrôle indisponible.'));
    };
    worker.onerror = () => { finir(); reject(new Error('Contrôle anti-abus indisponible.')); };
    worker.postMessage(defi);
  });
}
